import React from 'react';
import { RefreshCcw, CheckCircle } from 'lucide-react';

const PracticeMistakes = ({ isDarkMode }) => {
  const features = [
    { title: 'Automated Mistake Vault', desc: 'Every wrong answer is automatically saved for later review' },
    { title: 'Targeted Spaced Repetition', desc: 'Questions resurface at optimal intervals for memory retention' },
    { title: 'Zero Wasted Time', desc: 'Focus only on what you need to learn, skip what you know' }
  ];

  return (
    <section data-testid="section-practice-mistakes" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <span className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold mb-4 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`}>
              <RefreshCcw className="w-4 h-4" />
              Smart Learning
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-['Outfit'] tracking-tight mb-4">
              Practice Your Mistakes Until Perfect
            </h2>
            <p className={`text-base sm:text-lg mb-6 ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>
              Our AI-driven mistake repetition engine turns incorrect answers into targeted flash-quizzes. Stop wasting time on concepts you've already mastered.
            </p>
            <ul className="space-y-4">
              {features.map((item, i) => (
                <li key={i} className="flex items-start gap-4">
                  <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center ${isDarkMode ? 'bg-purple-900/50' : 'bg-purple-100'}`}>
                    <CheckCircle className={`w-5 h-5 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
                  </div>
                  <div>
                    <h4 className="font-bold mb-1">{item.title}</h4>
                    <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>{item.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className={`rounded-2xl p-6 sm:p-8 ${isDarkMode ? 'bg-[#131C2E] border border-slate-800' : 'bg-white border border-slate-200'} shadow-xl`}>
            <div className={`text-center p-8 rounded-xl ${isDarkMode ? 'bg-slate-800/50' : 'bg-purple-50'}`}>
              <RefreshCcw className={`w-16 h-16 mx-auto mb-4 ${isDarkMode ? 'text-purple-400' : 'text-purple-600'}`} />
              <h3 className="text-xl font-bold mb-2">Mistake Review</h3>
              <p className={`text-sm mb-4 ${isDarkMode ? 'text-slate-400' : 'text-slate-600'}`}>12 questions ready for review</p>
              <div className="flex gap-2 justify-center flex-wrap">
                {['Math', 'Science', 'English'].map((tag, i) => (
                  <span key={i} className={`px-3 py-1 rounded-full text-xs font-medium ${isDarkMode ? 'bg-slate-700 text-slate-300' : 'bg-white text-slate-600'}`}>
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PracticeMistakes;
